import { useQuery, useMutation, useApolloClient } from '@apollo/client'
import { useContext } from 'react'
import { PtSiteCtx } from '../CustomSiteF/CustomSiteWrapperF'

export const useQueryNext = (query, options={}) => {
  const client = useApolloClient()
  return useQuery(query, {
    ...options,
    client
  })
}

export const useMutationNext = (query, options) => {
  const client = useApolloClient()
  return useMutation(query, {client, ...options})
}


export const fmtError = ({error}) => {
  const {fmtSiteError} = useContext(PtSiteCtx)
  return fmtSiteError({error})
}